import { Id } from 'types';
import { Contract, ContractStatusId } from 'pricing/types';
import { apiContract } from 'utilities/http/api/pricing/apiContract';

export const putContractStatusActive = async (contractId: Id): Promise<Contract> => {
  const respStartContract = await apiContract.putContract(contractId, {
    breederContractStatusId: ContractStatusId.Active,
  });

  if (!respStartContract.isOk) {
    throw Error(respStartContract.json.message || `Couldn't active contract`);
  }

  return respStartContract.json.contract;
};
